import { useState, useRef, useEffect, FC, ReactNode } from "react";

interface ReadMoreProps {
  children: ReactNode;
  lines?: number;
}

const ReadMore: FC<ReadMoreProps> = ({ 
  children, 
  lines = 3 
}) => {
  const [expanded, setExpanded] = useState<boolean>(false);
  const [shouldTruncate, setShouldTruncate] = useState<boolean>(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = contentRef.current;
    if (el) {
      const fullHeight = el.scrollHeight;
      const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
      const maxAllowedHeight = lines * lineHeight;

      if (fullHeight > maxAllowedHeight) {
        setShouldTruncate(true);
      }
    }
  }, [children, lines]);

  const toggleExpanded = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <div>
      <div
        className="fs-16 fw-400 text-black"
        ref={contentRef}
        style={{
          display: "-webkit-box",
          WebkitLineClamp: expanded ? "unset" : lines,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {children}
      </div>

      {shouldTruncate && (
        <span
          className="fw-700 text-decoration-underline cursor-pointer"
          onClick={toggleExpanded}
        >
          {expanded ? "See less" : "Read more"}
        </span>
      )}
    </div>
  );
};

export default ReadMore;